<script>
import Fancybox from "../utils/Fancybox.js";

export default {
  name: "StdLink",
  props: {
    href: String,
    rel: String,
    target: String,
    fancybox: Boolean,
    video: Boolean,
  },
  computed: {
    isExternal() {
      const url = new URL(this.href, window.location.href);
      return url.host !== window.location.host;
    },
    targetOut() {
      if (!this.fancybox && !this.video) {
        if (this.target) {
          return this.target;
        }

        if (!this.href) {
          return undefined;
        }

        if (this.isExternal) {
          return "_blank";
        }
      }

      return undefined;
    },
    relOut() {
      if (!this.fancybox && !this.video) {
        if (this.rel) {
          return this.rel;
        }

        if (!this.href) {
          return undefined;
        }

        if (this.isExternal) {
          return "nofollow";
        }
      }

      return undefined;
    },
  },
  methods: {
    async onClick(event) {
      if (this.video) {
        event.preventDefault();

        const scrollPosition = window.scrollY;
        const fancybox = new Fancybox([
          {
            src: this.href,
            type: "iframe",
            preload: false,
          },
        ]);

        const applyScroll = () => {
          window.scroll(0, scrollPosition);
        }

        fancybox.on("closing", applyScroll);
        fancybox.on("destroy", applyScroll);

        setTimeout(() => {
          document.querySelector(".fancybox__iframe").addEventListener('fullscreenchange', applyScroll);
        }, 100)
      }
    },
  },
  async mounted() {
    if (this.fancybox) {
      Fancybox.bind(this.$el);
    }
  },
};
</script>

<template>
  <a
    v-bind:href="href"
    v-bind:rel="relOut"
    v-bind:target="targetOut"
    @click="onClick"
  >
    <slot />
  </a>
</template>
